import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  advancePostingList: [],
  isLoading: true,
  exportAdvancePosting: [],
  isExportLoading: false,
};

const advancePostingSlice = createSlice({
  name: "AdvancePosting",
  initialState,
  reducers: {
    setAdvancePostingList(state, actions) {
      state.advancePostingList = actions.payload;
      state.isLoading = false;
    },
    setLoading(state, actions) {
        state.isLoading = actions.payload;
    },
    setExportAdvancePosting(state, actions) {
      state.exportAdvancePosting = actions.payload;
      state.isExportLoading = false;
    },
    setExportLoading(state, actions) {
      state.isExportLoading = actions.payload;
    }
  },
});

export const { setAdvancePostingList, setLoading, setExportAdvancePosting, setExportLoading } = advancePostingSlice.actions;

const advancePostingReducer = advancePostingSlice.reducer;

export default advancePostingReducer;
